/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_UndoInputs */

const en_common_editor_undo = /** @type {(inputs: Common_Editor_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const zh_common_editor_undo = /** @type {(inputs: Common_Editor_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Common_Editor_UndoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_undo = /** @type {((inputs?: Common_Editor_UndoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_UndoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_undo(inputs)
	return zh_common_editor_undo(inputs)
});
export { common_editor_undo as "common.editor.undo" }